// Action types
export const ActionTypes = {
  SET_DROPDOWN_PREDICTION: "SET_DROPDOWN_PREDICTION",
  SET_PREDICTION_ALL_HEIGHTS: "SET_PREDICTION_ALL_HEIGHTS",
};

// Actions
export function setDropdownPrediction(payload) {
  return {
    type: ActionTypes.SET_DROPDOWN_PREDICTION,
    payload,
  };
}

export function setPredictionAllHeights(payload) {
  return {
    type: ActionTypes.SET_PREDICTION_ALL_HEIGHTS,
    payload,
  };
}
